/**
 * Returns Dynamic Generated CSS
 */

import generateCSS from '@Controls/generate-css';
import generateCSSUnit from '@Controls/generate-css-unit';

function styling(props) {
	const {
		overallAlignment,
		headingTag,
		showTotaltimecolor,
		headingColor,
		headSpace,
		subHeadingColor,
		headFontFamily,
		headFontWeight,
		headFontSize,
		headFontSizeType,
		headFontSizeMobile,
		headFontSizeTablet,
		headLineHeight,
		headLineHeightType,
		headLineHeightMobile,
		headLineHeightTablet,
		subHeadFontFamily,
		subHeadFontWeight,
		subHeadFontSize,
		subHeadFontSizeType,
		subHeadFontSizeMobile,
		subHeadFontSizeTablet,
		subHeadLineHeight,
		subHeadLineHeightType,
		subHeadLineHeightMobile,
		subHeadLineHeightTablet,
		priceFontSizeType,
		priceFontSize,
		priceFontSizeTablet,
		priceFontSizeMobile,
		priceFontFamily,
		priceFontWeight,
		priceLineHeightType,
		priceLineHeight,
		priceLineHeightTablet,
		priceLineHeightMobile,
		timeSpace,
		costSpace,
		/* eslint-disable camelcase */
		row_gap,
		step_gap,
	} = props.attributes;

	let tabletSelectors = {};
	let mobileSelectors = {};

	let sGap = '' !== step_gap ? step_gap : 0;
	sGap += 30;

	const selectors = {
		' .block-editor-rich-text__editable.wpsp-howto-desc-text': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
		},
		' .wpsp-how-to-main-wrap p': {
			'margin-bottom': generateCSSUnit(row_gap, 'px'),
		},

		' .wpsp-how-to-main-wrap .wpsp-howto__source-wrap': {
			'margin-bottom': generateCSSUnit(row_gap, 'px'),
		},

		' .wpsp-how-to-main-wrap span.wpsp-howto__time-wrap': {
			'margin-bottom': generateCSSUnit(row_gap, 'px'),
		},

		' .wpsp-how-to-main-wrap span.wpsp-howto__cost-wrap': {
			'margin-bottom': generateCSSUnit(row_gap, 'px'),
		},

		' .wpsp-how-to-tools .wpsp-how-to-tools-child__wrapper:last-child': {
			'margin-bottom': generateCSSUnit(row_gap, 'px'),
		},

		' .wpsp-how-to-materials .wpsp-how-to-materials-child__wrapper:last-child':
			{
				'margin-bottom': generateCSSUnit(row_gap, 'px'),
			},
		' .wpsp-howto-steps__wrap .block-editor-block-list__block.wp-block': {
			'margin-bottom': generateCSSUnit(sGap, 'px'),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeNeeded-text': {
			'font-family': priceFontFamily,
			'font-weight': priceFontWeight,
			'font-size': generateCSSUnit(priceFontSize, priceFontSizeType),
			'line-height': generateCSSUnit(
				priceLineHeight,
				priceLineHeightType
			),
			color: showTotaltimecolor,
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeNeeded-value': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
			'margin-left': generateCSSUnit(timeSpace, 'px'),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeINmin-text ': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-text': {
			'font-family': priceFontFamily,
			'font-weight': priceFontWeight,
			'font-size': generateCSSUnit(priceFontSize, priceFontSizeType),
			'line-height': generateCSSUnit(
				priceLineHeight,
				priceLineHeightType
			),
			color: showTotaltimecolor,
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-value': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
			'margin-left': generateCSSUnit(costSpace, 'px'),
		},

		' .wpsp-howto-steps__wrap h4.block-editor-rich-text__editable': {
			'font-family': priceFontFamily,
			'font-weight': priceFontWeight,
			'font-size': generateCSSUnit(priceFontSize, priceFontSizeType),
			'line-height': generateCSSUnit(
				priceLineHeight,
				priceLineHeightType
			),
		},
		' .wpsp-howto-steps__wrap p.block-editor-rich-text__editable': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
		},

		' .block-editor-rich-text__editable.wpsp-howto-estcost-type': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
		},

		' .block-editor-rich-text__editable.wpsp-howto-req-tools-text': {
			'font-family': priceFontFamily,
			'font-weight': priceFontWeight,
			'font-size': generateCSSUnit(priceFontSize, priceFontSizeType),
			'line-height': generateCSSUnit(
				priceLineHeight,
				priceLineHeightType
			),
			color: showTotaltimecolor,
		},

		'  .block-editor-rich-text__editable.wpsp-tools__label': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
		},

		' .block-editor-rich-text__editable.wpsp-howto-req-materials-text': {
			'font-family': priceFontFamily,
			'font-weight': priceFontWeight,
			'font-size': generateCSSUnit(priceFontSize, priceFontSizeType),
			'line-height': generateCSSUnit(
				priceLineHeight,
				priceLineHeightType
			),
			color: showTotaltimecolor,
		},

		' .block-editor-rich-text__editable.wpsp-howto-req-steps-text': {
			'font-family': priceFontFamily,
			'font-weight': priceFontWeight,
			'font-size': generateCSSUnit(priceFontSize, priceFontSizeType),
			'line-height': generateCSSUnit(
				priceLineHeight,
				priceLineHeightType
			),
			color: showTotaltimecolor,
		},

		' .block-editor-rich-text__editable.wpsp-materials__label': {
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
		},
	};

	selectors[' .wpsp-how-to-main-wrap'] = {
		'text-align': overallAlignment,
		display: 'block',
	};

	selectors[
		' ' +
			headingTag +
			'.block-editor-rich-text__editable.wpsp-howto-heading-text'
	] = {
		'font-family': headFontFamily,
		'font-weight': headFontWeight,
		'font-size': generateCSSUnit(headFontSize, headFontSizeType),
		'line-height': generateCSSUnit(headLineHeight, headLineHeightType),
		color: headingColor,
		'margin-bottom': generateCSSUnit(headSpace, 'px'),
	};

	mobileSelectors[
		' ' +
			headingTag +
			'.block-editor-rich-text__editable.wpsp-howto-heading-text'
	] = {
		'font-size': generateCSSUnit(headFontSizeMobile, headFontSizeType),
		'line-height': generateCSSUnit(
			headLineHeightMobile,
			headLineHeightType
		),
	};

	tabletSelectors[
		' ' +
			headingTag +
			'.block-editor-rich-text__editable.wpsp-howto-heading-text'
	] = {
		'font-size': generateCSSUnit(headFontSizeTablet, headFontSizeType),
		'line-height': generateCSSUnit(
			headLineHeightTablet,
			headLineHeightType
		),
	};

	mobileSelectors = {
		' .block-editor-rich-text__editable.wpsp-howto-desc-text': {
			'font-size': generateCSSUnit(
				subHeadFontSizeMobile,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightMobile,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeNeeded-text': {
			'font-size': generateCSSUnit(
				priceFontSizeMobile,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightMobile,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeNeeded-value': {
			'font-size': generateCSSUnit(
				subHeadFontSizeMobile,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightMobile,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeINmin-text ': {
			'font-size': generateCSSUnit(
				subHeadFontSizeMobile,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightMobile,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-text': {
			'font-size': generateCSSUnit(
				priceFontSizeMobile,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightMobile,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-value': {
			'font-size': generateCSSUnit(
				subHeadFontSizeMobile,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightMobile,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-type': {
			'font-size': generateCSSUnit(
				subHeadFontSizeMobile,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightMobile,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-tools__label': {
			'font-size': generateCSSUnit(
				priceFontSizeMobile,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightMobile,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-req-tools-text': {
			'font-size': generateCSSUnit(
				priceFontSizeMobile,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightMobile,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-materials__label': {
			'font-size': generateCSSUnit(
				priceFontSizeMobile,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightMobile,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-req-materials-text': {
			'font-size': generateCSSUnit(
				priceFontSizeMobile,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightMobile,
				priceLineHeightType
			),
		},
	};

	tabletSelectors = {
		' .block-editor-rich-text__editable.wpsp-howto-desc-text': {
			'font-size': generateCSSUnit(
				subHeadFontSizeTablet,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightTablet,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeNeeded-text': {
			'font-size': generateCSSUnit(
				priceFontSizeTablet,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightTablet,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeNeeded-value': {
			'font-size': generateCSSUnit(
				subHeadFontSizeTablet,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightTablet,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-timeINmin-text ': {
			'font-size': generateCSSUnit(
				subHeadFontSizeTablet,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightTablet,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-text': {
			'font-size': generateCSSUnit(
				priceFontSizeTablet,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightTablet,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-value': {
			'font-size': generateCSSUnit(
				subHeadFontSizeTablet,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightTablet,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-estcost-type': {
			'font-size': generateCSSUnit(
				subHeadFontSizeTablet,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightTablet,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-tools__label': {
			'font-size': generateCSSUnit(
				priceFontSizeTablet,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightTablet,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-req-tools-text': {
			'font-size': generateCSSUnit(
				priceFontSizeTablet,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightTablet,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-materials__label': {
			'font-size': generateCSSUnit(
				priceFontSizeTablet,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightTablet,
				priceLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-howto-req-materials-text': {
			'font-size': generateCSSUnit(
				priceFontSizeTablet,
				priceFontSizeType
			),
			'line-height': generateCSSUnit(
				priceLineHeightTablet,
				priceLineHeightType
			),
		},
	};

	const baseSelector = `.block-editor-page #wpwrap .wpsp-block-${props.clientId.substr(
		0,
		8
	)}`;

	let stylingCss = generateCSS(selectors, baseSelector);

	stylingCss += generateCSS(tabletSelectors, baseSelector, true, 'tablet');

	stylingCss += generateCSS(mobileSelectors, baseSelector, true, 'mobile');

	return stylingCss;
}

export default styling;
